import React, { useEffect, useState } from 'react';
import AolMainComponent from '../../components/aol/aol-main/AolMain';
import { QueryParamValueProps, useQueryParamsHandler } from 'odfjell-query-manager';
import { PageType } from 'src/types/Page';
import { PageContentWrapper } from './aol.styles';
import { useAolStore } from 'src/context/AolContext';
import { AolPageEnum } from 'src/enums/aol/AolPageEnum';

const AolComponent: React.FC = () => {
    const { triggerQueryParamsUpdate, queryParamUpdate } = useQueryParamsHandler();
    const [page, setPage] = useState<PageType | null>(null);
    const { setActiveAolPage } = useAolStore();

    useEffect(() => {
        if (queryParamUpdate) {
            if (!hasQueryFilterParams(queryParamUpdate.queryParamValues)) {
                const queryParamValues: QueryParamValueProps[] = [{ name: 'page', newValue: 'reporting' }];

                // const clearParamsList: string[] = ['portCallId', 'reportLocation'];
                // triggerQueryParamsUpdate(queryParamValues, clearParamsList);
                triggerQueryParamsUpdate(queryParamValues);
            } else {
                let _page: PageType = null;

                queryParamUpdate.queryParamValues.forEach((param) => {
                    if (param.name === 'page' && param.newValue === 'reporting') {
                        _page = param.newValue;
                        setActiveAolPage(AolPageEnum.Reporting);
                    } else if (param.name === 'page' && param.newValue === 'approval') {
                        _page = param.newValue;
                        setActiveAolPage(AolPageEnum.Approval);
                    } else if (param.name === 'page' && param.newValue === 'approved') {
                        _page = param.newValue;
                        setActiveAolPage(AolPageEnum.Approved);
                    }
                    setPage(_page);
                });
            }
        }
    }, [queryParamUpdate]);

    const hasQueryFilterParams = (params: QueryParamValueProps[]): boolean => {
        let hasfoundUrlParams = false;
        params.forEach((param) => {
            if (param.name === 'page' && param.newValue) {
                hasfoundUrlParams = true;
            }
        });

        return hasfoundUrlParams;
    };

    return <PageContentWrapper>{page && <AolMainComponent page={page} />}</PageContentWrapper>;
};
export default AolComponent;
